// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  InventoryFilters,
  UNPAGINATED_INVENTORY_LIMIT,
  assetsInventoryResponseSchema,
} from '@/inventory/api/types';
import queryString from 'query-string';

/**
 * Gets assets NOT in inventory with optional filters
 *
 * Endpoint: GET /v1/inventory/assets
 *
 * @param filters - Optional filters to apply to the assets inventory query
 * @returns Promise resolving to assets inventory response
 */
export async function getAssetsInventory(filters?: InventoryFilters) {
  const url = '/v1/inventory/assets';
  const response = await api.get(url, {
    paramsSerializer: (parameters) => queryString.stringify(parameters),
    params: { ...filters, limit: UNPAGINATED_INVENTORY_LIMIT },
  });
  return parseResponse(assetsInventoryResponseSchema, response.data, {
    schemaName: 'AssetsInventory',
    endpoint: url,
  });
}
